import { CATEGORY_COLOR, CATEGORY_COLOR_FALLBACK } from './calendar.constants';
import { RbcEvent } from './calendar.types';

interface CalendarEventPillProps {
  event: RbcEvent;
}

const CalendarEventPill = ({ event }: CalendarEventPillProps) => {
  const color =
    CATEGORY_COLOR[event.resource.category] ?? CATEGORY_COLOR_FALLBACK;

  return (
    <div
      className="pl-3 pr-[2px] py-1 flex flex-col items-start rounded-[2px]"
      style={{ borderLeft: `3px solid ${color}`, color }}
      title={event.resource.title}
      data-ai-item="Filing"
      data-ai-id={event.id}
    >
      <span className="txt-extra-small-bold whitespace-nowrap overflow-hidden text-ellipsis block w-full">
        {event.resource.title}
      </span>
    </div>
  );
};

export default CalendarEventPill;
